import { Box } from "@mui/material";
import { theme } from "@theme";
import type { ReactNode } from "react";

type PreferenceStepProps = { children: ReactNode; layout?: "grid" | "list" };

export const PreferenceStep = ({
  children,
  layout = "grid",
}: PreferenceStepProps) => (
  <Box
    sx={{
      marginTop: 3,
      padding: 3,
      borderRadius: 5,
      background: theme.palette.info.light,
    }}
  >
    <Box
      sx={{
        display: "grid",
        gap: layout === "list" ? 1.5 : 2,
        gridTemplateColumns:
          layout === "list" ? "1fr" : "repeat(3, minmax(0, 1fr))",
      }}
    >
      {children}
    </Box>
  </Box>
);
